export default __webpack_public_path__ + "static/media/back-arrow.31519300.svg";